import React from "react";
import JackpotButtonCard from "./JackpotButtonCard";
import ButtonCard from "./ButtonCard";
import FilledButton from "./FilledButton";
import LearnButton from "../common/LearnButton";

const CryptoHuntHomeOptions = ({
  isActive,
  handleStartButton,
  dailyLeft,
  currentReward,
  totalReward,
}) => {
  return (
    <>
      {isActive ? (
        <div className="flex flex-col sm:gap-y-5 xs:gap-y-4 gap-y-2 pb-4 items-center w-full">
          <LearnButton
            redirect={
              "https://medium.com/@blazpay/match-earn-repeat-conquer-the-memory-game-challenge-f4febec875a1"
            }
            title={"Learn to Play"}
            className={""}
          />
          <div className="flex sm:gap-x-6 gap-x-4">
            <CryptoHuntRewardCard
              text="Current Rewards"
              value={currentReward}
            />
            <CryptoHuntRewardCard text="Total Rewards" value={totalReward} />
          </div>
          {dailyLeft === 0 ? (
            <ButtonCard
              module="crypto-hunt"
              text={
                "You have exhausted all your attempts for today. Please try again tomorrow"
              }
            />
          ) : (
            <>
              <ButtonCard
                module="crypto-hunt"
                text={"Daily Left"}
                className={""}
                value={dailyLeft}
              />
              <FilledButton
                handleClick={handleStartButton}
                text={"Start"}
                isLoading={false}
                loadintText={"Loading..."}
              />
            </>
          )}
        </div>
      ) : null}
    </>
  );
};

export default CryptoHuntHomeOptions;

const CryptoHuntRewardCard = ({ text, value }) => {
  return (
    <div className="flex flex-col items-center sm:gap-y-5 xs:gap-3 gap-y-2">
      <div
        style={{
          boxShadow: "0 0 20px rgba(255,255,255,0.4) inset",
        }}
        className={`
          2xl:px-12 sm:px-8 xs:px-5 px-4 2xl:py-4 sm:py-2 xs:py-[6px] py-1 w-fit bg-black   rounded-full border-2 border-primary`}
      >
        <h1 className="font-redHat uppercase 2xl:text-xl sm:text-base xs:text-[14px] text-[10px] text-center">
          {text}
        </h1>
      </div>
      <div
        className={` ${
          value < 99999
            ? "2xl:w-[320px] xl:w-72 sm:w-56 xs:w-52 w-36  2xl:text-5xl xl:text-4xl sm:text-3xl xs:text-2xl text-xl"
            : "2xl:text-5xl xl:text-4xl text-3xl px-10  w-fit"
        } border 2xl:py-20 xl:py-16 sm:py-[56px] xs:py-12 py-8 bg-black lg:rounded-[36px] md:rounded-[30px] rounded-3xl font-bold font-akira flex items-center justify-center`}
      >
        <h1>{value}</h1>
      </div>
    </div>
  );
};
